import React, { useRef, useLayoutEffect } from 'react'
import Explanation from './Explanation/Explanation'
import { debounce } from 'lodash'
import './video.scss'


function Video({ type, uri, imguri, title, subtitle, key ,poster}) {
 
  const videoRef = useRef(null)

  const handleVideoClick = () => {
    if(videoRef.current) {
      videoRef.current.play()
    }
  }

  const video =
    <div className="video">
      <video muted autoplay="autoplay" ref={videoRef}onClick={handleVideoClick} src={uri} loop webkit-playsinline="true" playsInline={true} poster={poster} ></video>
    </div>
  const explanation =
    <Explanation key={key} type={type} imguri={imguri} title={title} subtitle={subtitle} type={type}></Explanation>
  const content = type == 'left' ? [explanation, video] : [video, explanation]
  const mobileContent = [explanation, video]
  return <div className="video_container">
    <div className="pc_content">
      {content}
    </div>
    <div className="mobile_content">
      {mobileContent}
    </div>
  </div>
}

export default Video